export type UserDocument = {
	Serial: string;
	State: string;
	Path: string;
	Type: string | null;
	Owner: string;
	CreatedAt: string;
	SignedAt: string | null;
	Expiration: string;
	// Lineage / public retrieval. snake_case, unlike the attributes above:
	// these come from the DOC item's feature fields rather than its base
	// attributes. All three are optional while the backend rolls them out.
	lineage_added?: boolean;
	public_retrieval?: boolean;
	public_revoked_at?: string | null;
};

export type PublicRetrievalStatus = 'active' | 'withdrawn' | 'none';

// The one place that reads the lineage fields off a document. Everything else
// branches on this, so a field rename stays a one-line change.
export function readPublicRetrievalStatus(
	document: Pick<UserDocument, 'public_retrieval' | 'public_revoked_at'>,
): PublicRetrievalStatus {
	if (document.public_retrieval === true) {
		return 'active';
	}
	// A revocation timestamp without the flag is the withdrawn case; the flag
	// is cleared when the owner retires the public copy.
	if (document.public_revoked_at) {
		return 'withdrawn';
	}
	return 'none';
}
